"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _require = require('../../errors'),
    CramUnimplementedError = _require.CramUnimplementedError;

var CramCodec = require('./_base');

var GammaCodec =
/*#__PURE__*/
function (_CramCodec) {
  (0, _inherits2.default)(GammaCodec, _CramCodec);

  function GammaCodec() {
    var _this;

    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dataType = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2.default)(this, GammaCodec);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GammaCodec).call(this, parameters, dataType));

    if (_this.dataType !== 'int') {
      throw new CramUnimplementedError("".concat(_this.dataType, " decoding not yet implemented by GAMMA codec"));
    }

    return _this;
  }

  (0, _createClass2.default)(GammaCodec, [{
    key: "decode",
    value: function decode(slice, coreDataBlock, blocksByContentId, cursors) {
      var length = 1;

      while (this._getBits(coreDataBlock.content, cursors.coreBlock, 1) === 0) {
        length += 1;
      }

      var readBits = this._getBits(coreDataBlock.content, cursors.coreBlock, length - 1);

      var value = readBits | 1 << length - 1;
      return value - this.parameters.offset;
    }
  }]);
  return GammaCodec;
}(CramCodec);

module.exports = GammaCodec;